module.exports = __webpack_public_path__ + "img/icon-minus.d45caf8b.svg";